<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <card style="min-height: 800px">
          <b-row>
            <b-col cols="6" style="padding: 20px 0 0 40px">
              <stats-card
                v-if="validationRunning"
                type="default"
                icon="gear 1.3 spin"
                :small-title="$t('data_import.validation')"
                :title="$t('data_import.validation_status.running')"
              >
                <div class="stats" slot="footer">
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataValidation()"
                    :disabled="true"
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run') }}
                  </b-button>
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <div class="time">{{ validationStarted }}</div>
                </div>
              </stats-card>

              <stats-card
                v-if="!validationRunning && validationResult == 'OK'"
                type="success"
                icon="check 1.9"
                :small-title="$t('data_import.validation')"
                :title="$t('data_import.validation_status.ok')"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataValidation()"
                    :disabled="validationRunning || importRunning"
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run') }}
                  </b-button>
                </div>
              </stats-card>

              <stats-card
                v-if="!validationRunning && validationResult == 'ERROR'"
                type="danger"
                icon="exclamation-triangle 1.3"
                :small-title="$t('data_import.validation')"
                :title="$t('data_import.validation_status.error')"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataValidation()"
                    :disabled="validationRunning || importRunning"
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run') }}
                  </b-button>
                </div>
              </stats-card>

              <stats-card
                v-if="!validationRunning && validationResult == 'UNKNOWN'"
                type="default"
                icon="dash 1.3"
                :small-title="$t('data_import.validation')"
                title="-"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataValidation()"
                    :disabled="validationRunning || importRunning"
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run') }}
                  </b-button>
                </div>
              </stats-card>

              <stats-card
                v-if="importRunning"
                type="default"
                icon="gear 1.3 spin"
                :small-title="$t('data_import.import')"
                :title="$t('data_import.import_status.running')"
              >
                <div class="stats" slot="footer">
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataImport()"
                    :disabled="true"
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run_import') }}
                  </b-button>
                  <div class="time">{{ validationStarted }}</div>
                </div>
              </stats-card>

              <stats-card
                v-if="!importRunning && importResult == 'ERROR'"
                type="danger"
                icon="exclamation-triangle 1.3"
                :small-title="$t('data_import.import')"
                :title="$t('data_import.validation_status.error')"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataImport()"
                    :disabled="
                      uiImportLock || validationRunning || importRunning
                    "
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run_import') }}
                  </b-button>
                </div>
              </stats-card>

              <stats-card
                v-if="!importRunning && importResult == 'UNKNOWN'"
                type="default"
                icon="dash 1.3"
                :small-title="$t('data_import.import')"
                title="-"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataImport()"
                    :disabled="
                      uiImportLock || validationRunning || importRunning
                    "
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run_import') }}
                  </b-button>
                </div>
              </stats-card>
              <stats-card
                v-if="!importRunning && importResult == 'OK'"
                type="success"
                icon="check 1.9"
                :small-title="$t('data_import.import')"
                :title="$t('data_import.validation_status.ok')"
              >
                <div class="stats" slot="footer">
                  <div v-if="fileUploaded && importFile">
                    {{ importFile.name }}
                  </div>
                  <b-button
                    type="submit"
                    class="btn-success btn-report"
                    @click="dataImport()"
                    :disabled="
                      uiImportLock || validationRunning || importRunning
                    "
                  >
                    <b-icon
                      icon="arrow-clockwise"
                      scale="1.2"
                      style="margin-right: 8px"
                    ></b-icon>
                    {{ $t('data_import.run_import') }}
                  </b-button>
                </div>
              </stats-card>
              <div>
                <ImportUiLock
                  @ui-lock-changed="handleUiLockChange"
                  ref="uiLock"
                />
              </div>
            </b-col>
            <!-- <b-col cols="1"></b-col> -->
            <b-col cols="6">
              <b-table
                striped
                small
                :items="log"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="loading"
                sticky-header="700px"
                tbody-class="tableClass"
                tbody-tr-class="trClass"
              >
                <template #table-busy>
                  <Loading />
                </template>
              </b-table>
              <!--
                    <TablePagination
                        :total-rows="totalRows"
                        :per-page="perPage"
                        :currentPage="currentPage"
                        >
                    </TablePagination>
                    -->
            </b-col>
          </b-row>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import media from '@/store/content/media.js'
import StatsCard from '@/components/Misc/StatsCard'
import ImportUiLock from './ImportUiLock.vue'

export default {
  name: 'DataImport',
  components: { StatsCard, ImportUiLock },
  props: {
    media: {
      type: Object,
      default: function () {
        return {
          mediaId: null,
          name: null,
          mediaType: 'image',
          url: null,
          mediaUploadToken: null,
        }
      },
    },
  },
  data: function () {
    return {
      perPage: 300,
      currentPage: 1,
      loading: false,
      fields: [
        {
          key: 'logTs',
          label: this.$t('import_log_report.time'),
          sortable: true,
          formatter: (value) => {
            var date = new moment(value)
            return date.format('HH:mm:ss')
          },
        },
        { key: 'level', label: this.$t('import_log_report.level') },
        { key: 'text', label: this.$t('import_log_report.log') },
      ],
      log: [],
      statusUpdater: null,
      logUpdater: null,
      status: null,
      validationRequested: false,
      importRequested: false,
      uploadFileToken: null,
      importFile: null,
      localMedia: Object.assign({}, this.media),
      newMediaFile: null,
      fileUploaded: false,
      fileSelected: false,
      uploadError: false,
      requestLoading: false,
      okMsg: '',
      errorMsg: '',
      queryParams: {
        fileName: '',
      },
      uiImportLock: false,
    }
  },
  computed: {
    items() {
      return []
    },
    totalRows() {
      return this.items ? this.items.length : 0
    },
    statusAvailable() {
      return this.status != null && this.status.value != ''
    },
    validationRunning() {
      return this.validationRequested || this.statusAvailable
    },
    importRunning() {
      return this.importRequested || this.statusAvailable
    },
    importResult() {
      let result = 'UNKNOWN'
      if (this.log && this.log.length > 0) {
        result = 'OK'

        let checkMax = this.log.length < 5 ? this.log.length : 5

        for (let i = 0; i < checkMax; i++) {
          //console.log("log i: " + i + ", text:" + this.log[i].text);
          if (this.log[i].text.includes('error')) {
            result = 'ERROR'
            break
          }
        }
        //result = this.log[0].text.includes("error") ? "ERROR" : "OK";
      }
      return result
    },
    validationResult() {
      let result = 'UNKNOWN'
      if (this.log && this.log.length > 0) {
        result = 'OK'

        let checkMax = this.log.length < 5 ? this.log.length : 5

        for (let i = 0; i < checkMax; i++) {
          //console.log("log i: " + i + ", text:" + this.log[i].text);
          if (this.log[i].text.includes('error')) {
            result = 'ERROR'
            break
          }
        }
        //result = this.log[0].text.includes("error") ? "ERROR" : "OK";
      }
      return result
    },
    validationStarted() {
      let started = ''
      if (this.status && this.status.value != '') {
        var date = new moment(this.status.value)
        started = date.format('DD.MM.yyyy HH:mm:ss')
      }
      return started
    },
  },
  beforeCreate: function () {
    if (!this.$store.state.media) this.$store.registerModule('media', media)
  },
  created() {
    this.updateStatus()
    this.updateLog()
  },
  beforeDestroy() {
    clearTimeout(this.statusUpdater)
    clearTimeout(this.logUpdater)
  },
  watch: {
    importFile: function () {
      if (this.importFile == null) return
      this.fileSelected = true
      this.fileUploaded = false
    },
    media: function () {
      this.localMedia = Object.assign({}, this.media)
      this.resetData()
    },
  },
  methods: {
    resetData() {
      this.uploadFileToken = null
      this.importFile = null
      this.newMediaFile = null
      this.queryParams.fileName = ''
      this.resetRequestInfo()
    },
    resetRequestInfo() {
      this.requestLoading = false
      this.fileUploaded = false
      this.uploadError = false
    },
    uploadFileAndSave() {
      if (this.importFile && this.importFile.name) {
        this.resetRequestInfo()
        this.requestLoading = true
        this.localMedia.url = this.importFile.name

        this.$store
          .dispatch('media/uploadImportFile', this.importFile)
          .then((result) => {
            this.localMedia.mediaUploadToken = result
            this.save()
          })
          .catch(() => {
            this.requestLoading = false
            this.uploadError = true
            this.errorMsg = this.$t('media.request.errorFileMsg')
          })
      }
    },
    save() {
      let params = {
        mediaId: this.localMedia.mediaId,
        mediaType: this.localMedia.mediaType,
        mediaUploadToken: this.localMedia.mediaUploadToken,
        name: this.localMedia.name,
        url: this.localMedia.url,
      }
      this.$store
        .dispatch('media/saveImportFile', params)
        .then(() => {
          this.fileUploaded = true
          this.fileSelected = false
          this.okMsg = this.$t('media.request.okSaveMsg')
        })
        .catch(() => {
          this.uploadError = true
          this.errorMsg = this.$t('media.request.errorSaveMsg')
        })
        .finally(() => {
          this.requestLoading = false
          this.fileUploaded = true
        })
    },
    updateStatus() {
      clearTimeout(this.statusUpdater)
      this.$traveller_http
        .get('/traveller/restui/timetables/import/status')
        .then((response) => {
          this.status = response.data
        })
        .catch(() => {})
        .finally(() => {
          if (this.statusAvailable)
            this.validationRequested = this.importRequested = false

          this.statusUpdater = setTimeout(this.updateStatus, 5000)
        })
    },
    updateLog() {
      clearTimeout(this.logUpdater)
      this.$traveller_http
        .get('/traveller/restui/timetables/import/logs')
        .then((response) => {
          this.log = response.data
        })
        .catch(() => {})
        .finally(() => {
          this.logUpdater = setTimeout(this.updateLog, 5000)
        })
    },
    dataValidation() {
      if (this.importFile && this.importFile.name && this.fileUploaded) {
        this.queryParams.fileName = this.importFile.name
      }
      console.log('dataValidation importfile: ' + this.queryParams.fileName)
      this.validationRequested = true
      this.$traveller_http
        .get(
          '/traveller/restui/timetables/import/dataValidation',
          this.queryParams.fileName
        )
        .then((response) => {
          console.log(response.data)
          // Testing, simulate validation run
          this.simulateValidation()
        })
        .catch(() => {})
        .finally(() => {
          this.updateStatus()
        })
    },
    dataImport() {
      this.startUiLock()
      if (this.importFile && this.importFile.name && this.fileUploaded) {
        this.queryParams.fileName = this.importFile.name
      }
      console.log('dataImport importfile: ' + this.queryParams.fileName)
      this.importRequested = true
      this.$traveller_http
        .get(
          '/traveller/restui/timetables/import/dataImport',
          this.queryParams.fileName
        )
        .then((response) => {
          console.log(response.data)
          this.simulateImport()
        })
        .catch(() => {})
        .finally(() => {
          this.updateStatus()
        })
    },
    simulateValidation() {
      // 5 seconds validation
      setTimeout(() => {
        this.validationRequested = false
      }, 5000)
    },
    simulateImport() {
      // 5 seconds import
      setTimeout(() => {
        this.importRequested = false
      }, 5000)
    },
    startUiLock() {
      this.$refs.uiLock.lockImportOnUiSide()
    },
    handleUiLockChange(status) {
      this.uiImportLock = status
    },
  },
}
</script>

<style scoped>
.time {
  float: right;
}
</style>
